<template>
    <div>
        <div v-for="(address, i) in addresses">
            <div class="row mb-1">
                <div class="col-sm-6 col-12 mb-sm-0 mb-1">
                    <b-form-input v-model="address.address" size="sm" placeholder="Enter Address" :class="{'is-invalid': errors['addresses.'+i+'.address']}"  />
                </div>
                <div class="col-sm-6 col-12">
                    <b-form-input v-model="address.city" size="sm" placeholder="Enter City" :class="{'is-invalid': errors['addresses.'+i+'.city']}" />
                </div>
            </div>

            <div class="row mb-1">
                <div class="col-sm-7 col-12 mb-sm-0 mb-1">
                    <b-form-select v-model="address.state_id" size="sm" :options="stateOptions" :class="{'is-invalid': errors['addresses.'+i+'.state_id']}" />
                </div>
                <div class="col-sm-5 col-12">
                    <b-form-input v-model="address.zip" size="sm" placeholder="Enter Zip Code" :class="{'is-invalid': errors['addresses.'+i+'.zip']}" />
                </div>
            </div>

            <div class="row mb-1">
                <div class="col-12">
                    <v-select v-model="address.address_types" :options="addressTypeOptions" :class="{'is-invalid': errors.address_types}" :placeholder="`-- Select Address Type(s) --`" multiple size="sm" />
                </div>
            </div>

            <div class="row mb-1">
                <div class="col-6">
                    <b-form-radio v-model="is_primary" name="primary_address" :value="address.address" plain><span>Primary</span></b-form-radio>
                </div>
                <div class="col-6 text-right">
                    <a href="javascript:void(0)" class="text-danger" v-on:click="deleteAddress(i)"><i class="fa fa-trash"></i> Delete</a>
                </div>
            </div>

            <div class="text-danger mt-1" v-if="errors['addresses.'+i+'.address']">
                <ul class="list-unstyled mb-0">
                    <li v-for="err in errors['addresses.'+i+'.address']">{{ err }}</li>
                </ul>
            </div>
            <div class="text-danger mt-1" v-if="errors['addresses.'+i+'.city']">
                <ul class="list-unstyled mb-0">
                    <li v-for="err in errors['addresses.'+i+'.city']">{{ err }}</li>
                </ul>
            </div>
            <div class="text-danger mt-1" v-if="errors['addresses.'+i+'.state_id']">
                <ul class="list-unstyled mb-0">
                    <li v-for="err in errors['addresses.'+i+'.state_id']">{{ err }}</li>
                </ul>
            </div>
            <div class="text-danger mt-1" v-if="errors['addresses.'+i+'.zip']">
                <ul class="list-unstyled mb-0">
                    <li v-for="err in errors['addresses.'+i+'.zip']">{{ err }}</li>
                </ul>
            </div>

            <hr v-if="i < (addresses.length - 1)" />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            addresses: {
                type: Array,
                required: true,
            },

            states: {
                types: Array,
                required: true,
            }
        },

        data() {
            return {
                errors: {},
                is_primary: null,
            }
        },

        watch: {

        },

        computed: {

            stateOptions(){
                //Setup
                var options = [{value: null, text: '-- Select a State --'}];

                //Main Loop
                for(var i = 0; i < this.states.length; i++)
                {
                    options.push({value: this.states[i].id, text: this.states[i].state_name});
                }

                //Send it
                return options;
            },

            addressTypeOptions(){
                return this.$store.state.constants.addressTypes;
            },
        },

        methods: {
            addAddress(){
                //Push
                this.addresses.push({address: '', city: '', state_id: null, zip: '', is_primary: 0});
            },

            deleteAddress(i){
                //Confirm
                if(!confirm('Are you sure you want to delete this address: '+this.addresses[i].address))
                {
                    return;
                }

                //Splice
                this.addresses.splice(i, 1);
            },

            getAddresses(){
                //Set primary
                for (var i = this.addresses.length - 1; i >= 0; i--)
                {
                    if(this.addresses[i].address === this.is_primary)
                    {
                        this.addresses[i].is_primary = 1;
                    }
                    else
                    {
                        this.addresses[i].is_primary = 0;
                    }
                }

                //Get the addresses
                return this.addresses;
            },

            setErrors(errors){
                //Set the errors
                this.errors = errors
            },

            setPrimary(){
                //Set primary
                for (var i = this.addresses.length - 1; i >= 0; i--)
                {
                    if(this.addresses[i].is_primary == 1)
                    {
                        this.is_primary = this.addresses[i].address;
                    }
                }
            },

        },

        mounted() {
            this.setPrimary();
        }
    }
</script>
